import { Field } from 'formik';
import { TextField as FormikMaterialUiTextField } from 'formik-material-ui';
import React from 'react';

type FieldProps = Parameters<typeof Field>[0];

export const TextField: React.FC<FieldProps> = (props) => {
  return <Field component={FormikMaterialUiTextField} {...props} />;
};
